module.exports = {
  mode: "jit",
  content: ["./**/*.html", "./**/*.php", "./src/**/*.css", "./src/**/*.js"],
  theme: {
    container: {
      center: true,
    },
    fontFamily: {
      body: ["Poppins"],
    },
    fontSize: {
      xs: ['0.625rem', 1.6], //10px
      "xs-var": ['0.75rem', 1.6], //12px
      sm: ['0.875rem', 1.5], //14px
      base: ['1rem', 1.5], //16px
      lg: ['1.125rem', 1.6], //18px
      xl: ['1.375rem', 1.5], //22px
      "2xl": ['1.5625rem', 1.3], //25px
      "3xl": ['2.0625rem', 1.5], //33px
      "4xl": ['2.75rem', 1.5], //44px
      "5xl": ['3.75rem', 1.2], //60px
    },
    spacing: {
      px: "1px",
      0: "0",
      2: "0.125rem", // 2px
      4: "0.25rem", // 4px
      6: "0.385rem", // 6px
      8: "0.5rem", // 8px
      10: "0.625rem", // 10px
      12: "0.75rem", // 12px
      14: "0.875rem", // 14px
      16: "1rem", // 16px
      17: "1.0625rem", // 17px
      18: "1.125rem", // 18px
      20: "1.25rem", // 20px
      22: "1.375rem", // 22px
      24: "1.5rem", // 24px
      26: "1.625rem", // 26px
      28: "1.75rem", // 28px
      30: "1.875rem", // 30px
      32: "2rem", // 32px
      34: "2.125rem", // 34px
      38: "2.375rem", // 38px
      40: "2.5rem", // 40px
      46: "2.875rem", // 46px
      48: "3rem", //48px
      52: "3.25rem", // 52px
      56: "3.5rem", // 56px
      58: "3.625rem", //58px
      62: "3.875rem", // 62px
      60: "3.75rem", // 60px
      64: "4rem", // 64px
      75: "4.6875rem", // 75px
      80: "5rem", // 80px
      85: "5.3125rem", // 85px
      96: "6rem", // 96px
      98: "6.125rem", // 98px
      104: "6.5rem", // 104px
      112: "7rem", // 112px
      115: "7.1875rem", // 115px
      144: "9rem", // 144px
      160: "10rem", // 160px
      180: "11.25rem" // 180px
    },
    extend: {
      colors: {
        gray: {
           50: "#f3f3f3",
          100: "#dadada",
          200: "#686868",
          300: "#2f2e2e",
          400: "#212427",
        },
        primary: {
          'cyan': '#47f2ed',
          'pink': '#ffbefa',
          'yellow': '#ffff82',
        },
        black: "#1b1a1c",
        white: "#f1f1f1",
      },
      borderRadius: {
        'md': '1.25rem', //20px
        'lg': '2.5rem', //40px
        'xl': '6.25rem', //100px
      },
      screens: {
        "sm-down": { max: "639px" },
        "md-down": { max: "767px" },
        "lg-down": { max: "1023px" },
        "xl-down": { max: "1279px" },
      },
      transformOrigin: {
        'rotated-frame': '60% 67%',
      },
    },
  },
  variants: {},
  plugins: [],
};
